import script from "./ToothGroupServiceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ToothGroupServiceSelector.vue?vue&type=script&setup=true&lang=js"

import "./ToothGroupServiceSelector.vue?vue&type=style&index=0&id=e5ba447c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ba447c"]])

export default __exports__